import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface CryptorTitleFieldProps {
  control: Control<CryptorFormData, {}>;
}

const CryptorTitleField: FC<CryptorTitleFieldProps> = ({ control }) => {
  return (
    <Controller
      control={control}
      name="title"
      render={({ field, fieldState }) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Titre"
          value={field.value}
          onChange={field.onChange}
          margin="normal"
          error={fieldState.invalid}
          fullWidth
        />
      )}
    />
  );
};

export default CryptorTitleField;
